const steps = [
  {
    n: "01",
    label: "Look Back",
    copy: "Notice what moved, what didn\u2019t and what got in the way.",
  },
  {
    n: "02",
    label: "Tell the Truth",
    copy: "Name what matters now without judging yourself for what happened before.",
  },
  {
    n: "03",
    label: "Choose Your Next Step",
    copy: "Decide what you\u2019re returning to and what would make the coming week feel meaningful.",
  },
  {
    n: "04",
    label: "Come Back",
    copy: "Return the next week without needing to prove anything or explain why life happened.",
  },
];

export function WhatHappensEachWeek() {
  return (
    <section
      data-testid="cc-each-week-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[56px] md:pt-[76px] pb-[56px] md:pb-[76px]">
        <div className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-[88px]">
          <div className="lg:col-span-4">
            <h2 className="font-display text-4xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-5 max-w-xs">
              A simple pause in the middle of real life.
            </h2>
            <p className="text-lg text-[#57534E] leading-relaxed max-w-xs">
              Each gathering gives you space to step out of the noise and
              look honestly at where you are.
            </p>
          </div>

          <div className="lg:col-span-8 space-y-8 md:space-y-10">
            {steps.map((s) => (
              <div key={s.n} data-testid={`cc-week-step-${s.n}`} className="flex items-start gap-6">
                <span className="font-display text-2xl md:text-3xl text-[#159E9A] w-10 flex-shrink-0 mt-1">
                  {s.n}
                </span>
                <div>
                  <p className="text-lg md:text-xl text-[#1C1917] font-medium mb-1">{s.label}</p>
                  <p className="text-base md:text-lg text-[#57534E] leading-relaxed max-w-md">{s.copy}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-[640px] mx-auto text-center mt-16 md:mt-20 mb-[48px] space-y-1">
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
            You can participate without being on camera.
          </p>
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">
            You can share or simply listen.
          </p>
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed pt-4">
            The goal is not to impress the room.
          </p>
          <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug pt-1">
            The goal is to stay connected to yourself.
          </p>
        </div>
      </div>
    </section>
  );
}
